import { getAudioUrl } from '@/api/audio'
import { kmsDecrypt, base64ToArrayBuffer } from '@/utils/kmsＭethod'
import Cookies from 'js-cookie'

const state = () => ({
  currentIdx: 0,
  playList: [],
  playImg: 'https://images.pexels.com/photos/3104/black-and-white-music-headphones-life.jpg?auto=compress&cs=tinysrgb&dpr=1&w=500',
  courseInfo: {
    pathname: '/org'
  },
  trackInfo: {},
  trackList: [],
  isPlaying: false,
  isShow: false,
  shutDownPlayer: true
})

const mutations = {
  setCurrentIdx: (state, idx) => {
    state.currentIdx = idx
  },
  setAudioList (state, audioList) {
    state.playList = audioList
    state.trackList = audioList
  },
  setAudioImg (state, audioImg) {
    state.playImg = audioImg
  },
  setCourseInfo (state, payload) {
    state.courseInfo = payload
  },
  setIsPlaying (state, payload) {
    state.isPlaying = payload
  },
  setIsShow (state, payload) {
    state.isShow = payload
  },
  setShutDownPlayer (state, payload) {
    state.shutDownPlayer = payload
  },
  setTrackInfo (state, obj) {
    console.log('3. setTrackInfo')
    console.log(obj)
    const index = obj.trackIndex
    if (Number.isInteger(index)) {
      if (index < 0 || index >= state.playList.length) return
      state.currentIdx = index
      console.log(state.currentIdx)
    } else {
      console.error('不合法的 identifier in setCurrentMusic')
      return
    }

    Cookies.remove('CloudFront-Key-Pair-Id')
    Cookies.remove('CloudFront-Policy')
    Cookies.remove('CloudFront-Signature')

    Cookies.set('CloudFront-Key-Pair-Id', obj.cookie['CloudFront-Key-Pair-Id'], { expires: 1, domain: '.jinfm.net' })
    Cookies.set('CloudFront-Policy', obj.cookie['CloudFront-Policy'], { expires: 1, domain: '.jinfm.net' })
    Cookies.set('CloudFront-Signature', obj.cookie['CloudFront-Signature'], { expires: 1, domain: '.jinfm.net' })

    state.trackInfo = obj
    console.log(state.trackInfo)
  }
}

const actions = {
  setAudioList ({ commit }, list) {
    commit('setAudioList', list)
  },
  setCourseInfo ({ commit }, info) {
    commit('setCourseInfo', info)
  },
  setTrackInfo ({ commit }, obj) {
    console.log(obj)
    return new Promise((resolve, reject) => {
      getAudioUrl(obj.trackId, obj.trackIsFree)
        .then((res) => {
          console.log(res)
          return res.data.data
        })
        .then((data) => {
          const uint8View = new Uint8Array(base64ToArrayBuffer(data))

          const audioParams = {
            CiphertextBlob: uint8View
          }
          // console.log(audioParams);
          return kmsDecrypt(audioParams)
        })
        .then((uint8array) => {
        // console.log(uint8array)
          const audioFile = JSON.parse(String.fromCharCode(...uint8array))
          // let cookieStr = JSON.stringify(audioFile.cookie)
          console.log(audioFile)
          obj.trackUrl = audioFile.url
          obj.cookie = audioFile.cookie
          commit('setTrackInfo', obj)
          resolve(obj)
        })
        .catch((err) => {
          console.log(err.response)
          reject(err.response)
        })
    })
    // commit('setTrackInfo', id)
  }
}

const getters = {
  mediaList: state => {
    return [{
      name: state.trackInfo.trackTitle,
      artist: state.trackInfo.trackId,
      url: state.trackInfo.trackUrl,
      type: 'customHls'

    }]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/audio.js